<template>
    <div>
        <div class="common-table">
            <el-table v-loading="loading" height="100%" :data="jpLog.beanList" row-key="opTime">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="注入彩池数量" min-width="120" align="center" prop="importJpChip"/>
                <el-table-column label="注入对应分池" min-width="120" align="center" prop="jpPoolName"/>
                <el-table-column label="注入对应子池" min-width="120" align="center" prop="jpTypeName"/>
                <el-table-column label="注入前彩池金豆" min-width="120" align="center" prop="beforeJpChips"/>
                <el-table-column label="注入后彩池金豆" min-width="120" align="center" prop="afterJpChips"/>
                <el-table-column label="注入前账户金豆余额" min-width="150" align="center" prop="beforeChips"/>
                <el-table-column label="注入后账户金豆余额" min-width="150" align="center" prop="afterChips"/>
                <el-table-column label="注入时间" width="150" align="center" prop="opTime"/>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="jpLog.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                currentPage:1
            }
        },
        computed: {
            ...mapState('market', ['jpLog'])
        },
        methods: {
            ...mapActions('market', ['getJpLogList']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getJpLogList(page).then(() => {
                    this.loading = false;
                })
            }
        }
    }
</script>
